import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      toast.success(`Welcome back, ${u.name || u.email}`);
      const fallback = u.role === "admin" ? "/admin" : `/suppliers/dashboard/${u.supplier_id}`;
      const target = loc.state?.from || fallback;
      nav(target, { replace: true });
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-xs font-mono-tech tracking-[0.25em] text-[#FF5100] mb-2">
        SUPPLIERS · SIGN IN
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-none mb-6">
        Welcome back.
      </h1>

      <form onSubmit={submit} data-testid="login-form" className="border border-neutral-200 bg-neutral-50 p-6 space-y-4">
        <Field label="Email">
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@workshop.co.za"
            className="w-full bg-white border border-neutral-200 focus:border-[#FF5100] outline-none px-3 h-11 text-sm"
          />
        </Field>
        <Field label="Password">
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
            className="w-full bg-white border border-neutral-200 focus:border-[#FF5100] outline-none px-3 h-11 text-sm"
          />
        </Field>
        <button
          type="submit"
          data-testid="login-submit"
          disabled={busy}
          className="w-full px-6 h-11 bg-[#FF5100] hover:bg-[#E64A00] disabled:opacity-50 text-white font-bold uppercase tracking-wider text-xs transition-colors"
        >
          {busy ? "Signing in..." : "Sign In"}
        </button>
        <div className="text-center text-xs">
          <Link to="/forgot-password" className="text-neutral-500 hover:text-[#FF5100]" data-testid="login-forgot-link">
            Forgot password?
          </Link>
        </div>
        <div className="text-center text-xs text-neutral-500 pt-2 border-t border-neutral-200">
          New supplier?{" "}
          <Link to="/suppliers/register" className="text-[#FF5100] hover:underline" data-testid="login-register-link">
            Create an account
          </Link>
        </div>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-[0.2em] font-mono-tech text-neutral-500 mb-1.5">
        {label}
      </div>
      {children}
    </label>
  );
}
